import { useRecoilState } from 'recoil';
import { licenseFormStateAtom } from '../OnBoardStep/components/Step4/Step4.atoms';

export function useLicenseFormState() {
  const [licenseFormState, setLicenseFormState] =
    useRecoilState(licenseFormStateAtom);

  return {
    licenseFormState,
    setLicenseFormState
  };
}
